import { FC, useEffect } from 'react';
import { useSendTaskMutation } from '../../api/tenders';
import { Button, message } from 'antd';
import { useAppSelector } from '../../hooks';
import { Loader } from '../Loader/Loader';
import { tenderDataProps } from '../../pages/TenderViewPage/types';
import Cancel from '../../assets/Cancel.svg';

import arrow from '../../assets/arrow-right-white.svg';
import './phases.scss';
import { CancelTender } from './CanceledPhaseComponents/CancelTender';

interface PropsPhase {
    data: tenderDataProps;
    setTrigger: React.Dispatch<React.SetStateAction<boolean>>;
    setConfirmModal: React.Dispatch<React.SetStateAction<boolean>>;
}

export const Canceled: FC<PropsPhase> = ({ data, setTrigger, setConfirmModal }) => {
    const [
        sendTask,
        { data: dataSendTask, isError: isErrorSendTask, isSuccess: isSuccessSendTask, isLoading: isLoadingSendTask }
    ] = useSendTaskMutation();

    const { role } = useAppSelector((state: any) => state.profileReducer);
    const [messageApi, contextHolder] = message.useMessage();

    const sendTaskFunc = async () => {
        if (isLoadingSendTask) return;
        const formData = {
            id: data?.id
        };
        try {
            await sendTask(formData).unwrap();
            await setTrigger((prev: boolean) => !prev);
        } catch {}
    };
    useEffect(() => {
        if (isErrorSendTask) {
            messageApi.error('Something went wrong, please try again');
        }
        if (isSuccessSendTask) {
            messageApi.success(dataSendTask.message);
        }
    }, [isErrorSendTask, isSuccessSendTask]);

    return (
        <>
            {contextHolder}
            <div className={`tendermain__block tasks`}>
                <div className="tasks__header define">
                    <div className="count-wrapper">
                        Task Centre
                        <div className="count">{data?.phase_task_count}</div>
                    </div>
                </div>

                {data.phase_tasks.length ? (
                    <div className="tasks__list">
                        <CancelTender data={data} role={role} setTrigger={setTrigger} />
                    </div>
                ) : (
                    <div className="noTasks">
                        <img src={Cancel} />
                        <div className="noTasks__title">Your Matchmaking Journey has been officially cancelled</div>
                        <div className="noTasks__subtitle" style={{ width: '408px' }}>
                            If you think this is a mistake, please immediately inform us by leaving us a message in the
                            chat.
                        </div>
                    </div>
                )}
                {role === 'super_admin' &&
                    data.phase_tasks[0]?.action === 'canceled_tender' &&
                    data.phase_tasks[0]?.status !== 'completed' && (
                        <div className="tasks__btn-wrap">
                            <div></div>

                            <Button
                                className={`tasks__next-btn ${!data?.can_send_task ? 'disabled' : ''}`}
                                type="primary"
                                onClick={() => {
                                    if (data?.can_send_task) {
                                        sendTaskFunc();
                                    }
                                }}
                            >
                                {isLoadingSendTask ? (
                                    <Loader />
                                ) : (
                                    <div className="flex">
                                        Confirm <img src={arrow} style={{ margin: '0 0 0 10px' }} />
                                    </div>
                                )}
                            </Button>
                        </div>
                    )}
            </div>
        </>
    );
};
